import type { LegendItem } from './types';

interface LegendFooterProps {
  items: LegendItem[];
}

/**
 * LegendFooter - Static legend component for PNG export mode
 *
 * Displays legend items in a horizontal, centered layout at the top of the footer.
 * This component is always visible (no hover state) to ensure proper screenshot capture.
 *
 * Layout: [■ Label] [■ Label] [■ Label] ...
 *
 * Used only in export mode - normal published views use the interactive Legend component.
 */
export function LegendFooter({ items }: LegendFooterProps) {
  if (items.length === 0) {
    return null;
  }

  return (
    <div
      className="w-full flex flex-wrap items-center justify-center gap-x-6 gap-y-2"
      data-component="legend-footer"
      data-item-count={items.length}
    >
      {items.map((item, index) => (
        <div key={`${item.label}-${item.color}-${index}`} className="flex items-center gap-2">
          <div
            className="w-4 h-4 rounded shrink-0"
            style={{ backgroundColor: item.color }}
            aria-hidden="true"
          />
          <span className="text-sm text-text-neutral-secondary whitespace-nowrap">
            {item.label}
          </span>
        </div>
      ))}
    </div>
  );
}
